import React, { Fragment, useEffect, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import AWS from "aws-sdk";
import Autocomplete from "react-google-autocomplete";
import * as mutations from "../../graphql/mutations";
import { toast } from "react-toastify";
import * as queries from "../../graphql/queries";
import {
  S3_BUCKET,
  REGION,
  ASSET_OWNER_FOLDER,
  COMPANY_FOLDER,
  SECRETACCESSKEY,
  ACCESSKEYID,
  USERPOOLID,
  limit,
} from "../../Config/Config";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

const Profile = () => {
  const LoginUserDetails =
    JSON.parse(localStorage.getItem("userDetails")) || {};
  const LoginUserGroup = localStorage.getItem("groups");

  AWS.config.update({
    accessKeyId: ACCESSKEYID,
    secretAccessKey: SECRETACCESSKEY,
  });
  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const [companyDetails, setCompanyDetails] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [downloadedFile, setdownloadedFile] = useState("");
  const [companyAdress, setCompanyAdress] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [addressError, setAddressError] = useState(false);
  const [siteAdress, setsiteAdress] = useState();
  const [siteAdressArray, setsiteAdressArray] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [emailError, setEmailError] = useState("");
  const [companyEmailError, setCompanyEmailError] = useState("");
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    companyEmail: "",
    address: "",
  });
  const onLoad = (autocomplete) => {
    setsiteAdress(autocomplete);
  };
  const onPlaceChanged = (detailAddress) => {
    console.log(detailAddress);
    let fullAddress1 = [];
    for (let i = 0; i < detailAddress.length; i++) {
      if (detailAddress[i].types.includes("postal_code")) {
        fullAddress1["postcode"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("locality")) {
        fullAddress1["suburb"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("administrative_area_level_1")) {
        fullAddress1["state"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("administrative_area_level_2")) {
        fullAddress1["street"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("country")) {
        fullAddress1["country"] = detailAddress[i].long_name;
      }
    }
    console.log(fullAddress1);
    setsiteAdressArray(fullAddress1);
  };

  const [formData, setFormData] = useState({
    username: LoginUserDetails.username || "",
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    companyEmail: "",
    address: "",
    logo: "",
  });

  const validateForm = () => {
    const newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.firstName?.trim()) {
      newErrors.firstName = "First Name is required";
    }

    if (!formData.lastName?.trim()) {
      newErrors.lastName = "Last Name is required";
    }

    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.companyName?.trim()) {
      newErrors.companyName = "Company Name is required";
    }

    if (!formData.companyEmail?.trim()) {
      newErrors.companyEmail = "Company Email is required";
    } else if (!emailRegex.test(formData.companyEmail)) {
      newErrors.companyEmail = "Please enter a valid company email";
    }

    if (!(companyAdress || formData.address)?.trim()) {
      newErrors.address = "Company Address is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getImage = async (filename) => {
    try {
      const params = {
        Bucket: S3_BUCKET,
        Key: `public/${COMPANY_FOLDER}/${filename}`,
      };

      const url = await myBucket.getSignedUrlPromise("getObject", params);

      setdownloadedFile(url);
    } catch (err) {
      console.error(err);
    }
  };
  //-------------------------------------------------------------------------
  const getfilename = (path) => {
    try {
      if (!path) return;

      // Plain filename
      getImage(path);
    } catch (error) {
      console.error(error);
    }
  };

  async function getCompany() {
    try {
      let company = null;
      let user = null;

      if (LoginUserGroup === "electrician") {
        const result2 = await client.graphql({
          query: queries.getSPUserDetails,
          variables: {
            id: LoginUserDetails.id,
          },
          authMode: "API_KEY",
        });

        user = result2?.data?.getSPUserDetails;

        const result = await client.graphql({
          query: queries.getSPCompanyDetails,
          variables: {
            id: LoginUserDetails.companyDetailsId,
          },
          authMode: "API_KEY",
        });

        company = result?.data?.getSPCompanyDetails;
      } else {
        const result2 = await client.graphql({
          query: queries.getAssetOwner,
          variables: {
            id: LoginUserDetails.id,
          },
          authMode: "API_KEY",
        });

        user = result2?.data?.getAssetOwner;

        const result = await client.graphql({
          query: queries.getCompanyDetails,
          variables: {
            id: LoginUserDetails.companyDetailsId,
          },
          authMode: "API_KEY",
        });

        company = result?.data?.getCompanyDetails;
      }

      console.log("User Details:", user);
      console.log("Company Details:", company);

      if (company) {
        setCompanyDetails(company);

        if (company.logo) {
          getfilename(company.logo);
        }

        setFormData({
          username: LoginUserDetails.username || "",
          firstName: user?.firstName || user?.fname || "",

          lastName: user?.lastName || user?.lname || "",

          email: user?.email || "",

          companyName: company?.companyName || company?.Name || "",

          companyEmail: company?.companyEmail || company?.email || "",

          address: company?.companyAddress || company?.address || "",

          logo: company?.logo || company?.companyLogo || "",
        });
        setOriginalData({
          username: LoginUserDetails.username || "",
          firstName: user?.firstName || user?.fname || "",

          lastName: user?.lastName || user?.lname || "",

          email: user?.email || "",

          companyName: company?.companyName || company?.Name || "",

          companyEmail: company?.companyEmail || company?.email || "",

          address: company?.companyAddress || company?.address || "",

          logo: company?.logo || company?.companyLogo || "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleCancel = () => {
    setFormData(originalData);
    setCompanyAdress("");
    setSelectedFile(null);
    setEmailError("");
    setEditMode(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // User Email Validation
    if (name === "email") {
      if (!value.trim()) {
        setEmailError("Email is required");
      } else if (!emailRegex.test(value)) {
        setEmailError("Please enter a valid email address");
      } else {
        setEmailError("");
      }
    }

    // Company Email Validation
    if (name === "companyEmail") {
      if (!value.trim()) {
        setCompanyEmailError("Company Email is required");
      } else if (!emailRegex.test(value)) {
        setCompanyEmailError("Please enter a valid company email");
      } else {
        setCompanyEmailError("");
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    // Validation
    if (!validateForm()) {
      return;
    }

    try {
      console.log("Updating data:", formData);
      console.log(selectedFile);
      // GraphQL Mutation Here

      if (LoginUserGroup === "electrician" || LoginUserGroup === "site_user") {
        const datalist = await client.graphql({
          query: mutations.updateSPUserDetails,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.id,
              fname: formData.firstName,
              lname: formData.lastName,
            },
          },
          authMode: "API_KEY",
        });
        console.log("user", datalist);
        if (LoginUserGroup === "electrician") {
          const datalist2 = await client.graphql({
            query: mutations.updateSPCompanyDetails,
            variables: {
              limit: limit,
              input: {
                id: LoginUserDetails.companyDetailsId,
                companyName: formData.companyName,
                companyAddress: companyAdress
                  ? companyAdress
                  : formData.address,
                logo: selectedFile ? selectedFile : formData.logo,
              },
            },
            authMode: "API_KEY",
          });
          console.log("comp", datalist2);
          const logodata = selectedFile ? selectedFile : formData.logo;
          getfilename(logodata);
        }
      } else if (LoginUserGroup === "spao") {
        const datalist = await client.graphql({
          query: mutations.updateAssetOwner,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.id,
              firstName: formData.firstName,
              //email: formData.email,
              lastName: formData.lastName,
            },
          },
          authMode: "API_KEY",
        });
        console.log("user", datalist);
        //--sp
        const datalist1 = await client.graphql({
          query: mutations.updateSPUserDetails,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.id,
              fname: formData.firstName,
              lname: formData.lastName,
            },
          },
          authMode: "API_KEY",
        });
        console.log("user", datalist1);
        //--
        const datalist2 = await client.graphql({
          query: mutations.updateCompanyDetails,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.companyDetailsId,
              companyName: formData.companyName,
              email: formData.companyEmail,
              companyAddress: companyAdress ? companyAdress : formData.address,
              logo: selectedFile ? selectedFile : formData.logo,
            },
          },
          authMode: "API_KEY",
        });
        console.log("comp", datalist2);
        //const logodata = selectedFile ? selectedFile : formData.logo;
        //---spcomp
        const datalist3 = await client.graphql({
          query: mutations.updateSPCompanyDetails,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.companyDetailsId,
              companyName: formData.companyName,
              companyAddress: companyAdress ? companyAdress : formData.address,
              logo: selectedFile ? selectedFile : formData.logo,
            },
          },
          authMode: "API_KEY",
        });
        console.log("comp", datalist3);
        const logodata = selectedFile ? selectedFile : formData.logo;
        getfilename(logodata);
      } else {
        const datalist = await client.graphql({
          query: mutations.updateAssetOwner,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.id,
              firstName: formData.firstName,
              lastName: formData.lastName,
            },
          },
          authMode: "API_KEY",
        });
        console.log("user", datalist);
        //--
        const datalist2 = await client.graphql({
          query: mutations.updateCompanyDetails,
          variables: {
            limit: limit,
            input: {
              id: LoginUserDetails.companyDetailsId,
              companyName: formData.companyName,
              email: formData.companyEmail,
              companyAddress: companyAdress ? companyAdress : formData.address,
              logo: selectedFile ? selectedFile : formData.logo,
            },
          },
          authMode: "API_KEY",
        });
        console.log("comp", datalist2);
        const logodata = selectedFile ? selectedFile : formData.logo;
        getfilename(logodata);
      }

      setOriginalData(formData);
      toast.success(`Profile Updated Successfully.`, {
        position: toast.POSITION.TOP_CENTER,
      });
      setEditMode(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      Key: `public/${COMPANY_FOLDER}/${file.name}`,
    };
    myBucket
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        const filedetails = [];
        filedetails.push({ fileName: file.name, type: file.type });
        console.log(filedetails[0].fileName);
        setSelectedFile(filedetails[0].fileName);
      })
      .send((err) => {
        if (err) console.log(err);
      });
  };

  return (
    <Fragment>
      <br></br>
      <br></br>
      <Container fluid={true}>
        <br></br>
        <Row>
          <Col md="12" className="project-list">
            <Card className="custom-card">
              <CardBody>
                <Row>
                  <Col md="3" className="text-center">
                    <img
                      src={
                        downloadedFile ||
                        "https://via.placeholder.com/180x180?text=Company+Logo"
                      }
                      alt="Company Logo"
                      className="img-fluid rounded shadow-sm"
                      style={{
                        maxWidth: "180px",
                        maxHeight: "180px",
                        objectFit: "contain",
                      }}
                    />

                    <h5 className="mt-3">{formData.companyName}</h5>
                  </Col>

                  <Col md="9">
                    {!editMode ? (
                      <>
                        <h3 className="mb-4">Profile Details</h3>

                        <Row>
                          <Col md="6" className="mb-3">
                            <label className="fw-bold">Username</label>
                            <div>{formData.username}</div>
                          </Col>

                          <Col md="6" className="mb-3">
                            <label className="fw-bold">Email</label>
                            <div>{formData.email}</div>
                          </Col>

                          <Col md="6" className="mb-3">
                            <label className="fw-bold">First Name</label>
                            <div>{formData.firstName}</div>
                          </Col>

                          <Col md="6" className="mb-3">
                            <label className="fw-bold">Last Name</label>
                            <div>{formData.lastName}</div>
                          </Col>

                          <Col md="6" className="mb-3">
                            <label className="fw-bold">Company Name</label>
                            <div>{formData.companyName}</div>
                          </Col>

                          <Col md="6" className="mb-3">
                            <label className="fw-bold">Company Email</label>
                            <div>{formData.companyEmail}</div>
                          </Col>

                          <Col md="12" className="mb-3">
                            <label className="fw-bold">Company Address</label>
                            <div>{formData.address}</div>
                          </Col>
                        </Row>

                        <Button
                          color="primary"
                          onClick={() => setEditMode(true)}
                        >
                          Edit Profile
                        </Button>
                      </>
                    ) : (
                      <>
                        <h3 className="mb-4">Update Profile</h3>

                        <Form>
                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <Label>Username</Label>
                                <Input value={formData.username} disabled />
                              </FormGroup>
                            </Col>

                            <Col md="6">
                              <FormGroup>
                                <Label>Email</Label>
                                <Input
                                  type="email"
                                  name="email"
                                  value={formData.email}
                                  disabled
                                />
                                {emailError && (
                                  <div className="text-danger mt-1">
                                    {emailError}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <Label>First Name</Label>
                                <Input
                                  name="firstName"
                                  value={formData.firstName}
                                  onChange={handleChange}
                                  invalid={!!errors.firstName}
                                />

                                {errors.firstName && (
                                  <div className="text-danger mt-1">
                                    {errors.firstName}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md="6">
                              <FormGroup>
                                <Label>Last Name</Label>
                                <Input
                                  name="lastName"
                                  value={formData.lastName}
                                  onChange={handleChange}
                                  invalid={!!errors.lastName}
                                />

                                {errors.lastName && (
                                  <div className="text-danger mt-1">
                                    {errors.lastName}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <Label>Company Name</Label>
                                <Input
                                  name="companyName"
                                  value={formData.companyName}
                                  onChange={handleChange}
                                  invalid={!!errors.companyName}
                                />

                                {errors.companyName && (
                                  <div className="text-danger mt-1">
                                    {errors.companyName}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md="6">
                              <FormGroup>
                                <Label>Company Email</Label>
                                <Input
                                  type="email"
                                  name="companyEmail"
                                  value={formData.companyEmail}
                                  onChange={handleChange}
                                  invalid={!!companyEmailError}
                                />

                                {companyEmailError && (
                                  <div className="text-danger mt-1">
                                    {companyEmailError}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Label>Company Address</Label>
                                {/* <Input
                                                        type="textarea"
                                                        rows="3"
                                                        name="address"
                                                        value={formData.address}
                                                        onChange={handleChange}
                                                    /> */}
                                <Autocomplete
                                  apiKey="AIzaSyBTumeD-l8p-2slpOP7PEJ7KKOlaFfOOj4"
                                  className="form-control"
                                  onPlaceSelected={(place) => {
                                    console.log(place);
                                    setCompanyAdress(place.formatted_address);
                                    const address = place.address_components;
                                    onPlaceChanged(address);
                                    if (place) {
                                      setAddressError(false);
                                    } else {
                                      setAddressError(true);
                                    }
                                  }}
                                  options={{
                                    types: ["address"],
                                    componentRestrictions: { country: "AU" },
                                  }}
                                  name="companyaddress"
                                  placeholder="Company Address"
                                  defaultValue={formData.address}
                                />
                                {errors.address && (
                                  <div className="text-danger mt-1">
                                    {errors.address}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Label>Company Logo</Label>
                                <Input
                                  type="file"
                                  name="companylogo"
                                  onChange={handleFileInput}
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <div className="mt-3">
                            <Button color="success" onClick={handleUpdate}>
                              Update Details
                            </Button>

                            <Button
                              color="primary"
                              className="ms-2"
                              onClick={handleCancel}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Form>
                      </>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Profile;
